import { createReducer, on, Action } from '@ngrx/store'

import * as SelectedItemActions from './selected-item.actions'
import { ItemEntity } from './selected-item.models'
import { FrontState } from 'libs/gb-front/core/data-access/src/lib/+state/front-state.models'
import { ItemTypeEnum } from 'libs/gb-front/item/data-access/src/lib/+state/items.models'
import { LockTypeEnum } from 'libs/shared/models/shared.models'

export const SELECTED_ITEM_FEATURE_KEY = 'selectedItem'

export interface SelectedItemState extends ItemEntity {
  loaded: boolean // has the SelectedItem list been loaded
  amount?: number // bid, donation, purchase or raffle purchase amount
}

export interface SelectedItemPartialState {
  readonly [SELECTED_ITEM_FEATURE_KEY]: SelectedItemState
}

export const initialState: SelectedItemState = {
  uuid: '',
  name: '',
  description: '',
  alias: '',
  auction: '',
  categories: [],
  footnote: '',
  image_cover: false,
  images: [],
  ioc: false,
  is_visible: false,
  item_type: '' as ItemTypeEnum,
  label: '',
  live_auction_item: false,
  lock: LockTypeEnum.None,
  lock_message: '',
  order: 0,
  order_hash: '',
  quantity: 0,
  sealed_auction_item: false,
  share_facebook: false,
  share_link: false,
  share_twitter: false,
  show_label: false,
  tax: '',
  bidding_item: null,
  purchase_item: null,
  donation_item: null,
  raffle_item: null,
  enable_activity_feed: false,
  next_id: null,
  prev_id: null,
  item_activity_feed_visibility: false,
  amount: 0,
  loaded: false,
  terms_and_conditions: '',
}

// lazy load state
export interface State extends FrontState {
  [SELECTED_ITEM_FEATURE_KEY]: SelectedItemState
}

export const selectedItemReducer = createReducer(
  initialState,
  on(SelectedItemActions.initSelectedItem, SelectedItemActions.clearSelectedItem, () => ({ ...initialState })),
  on(SelectedItemActions.initSelectedItemFieldsFromList, (state, { selectedItem }) => ({
    ...state,
    ...selectedItem,
  })),
  on(SelectedItemActions.syncSelectedItem, (state) => ({
    ...state,
    isStale: true,
  })),
  on(SelectedItemActions.syncSelectedItemSuccess, (state, { selectedItem }) => ({
    ...selectedItem,
    amount: state.amount,
    isStale: false,
    loaded: true,
  })),
  on(SelectedItemActions.syncSelectedItemFailure, (state, { error }) => ({
    ...state,
    loaded: true,
  })),
  on(SelectedItemActions.updateAmount, (state, { amount }) => ({
    ...state,
    amount,
  })),
  on(SelectedItemActions.clearAmount, (state) => ({
    ...state,
    amount: initialState.amount,
  })),
)

export function reducer(state: SelectedItemState | undefined, action: Action) {
  return selectedItemReducer(state, action)
}
